import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  addStorageLocation,
  fetchStorageLocationById,
  fetchStorageLocations,
  updateStorageLocation,
  updateStatusInStorageLocation,
} from "./thunk";

interface StorageLocationState {
  StorageLocationList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedStorageLocation: any;
}

const initialState: StorageLocationState = {
  StorageLocationList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedStorageLocation: null,
};

const StorageLocationSlice = createSlice({
  name: "StorageLocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStorageLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStorageLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.StorageLocationList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchStorageLocations.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch StorageLocations";
      })
      .addCase(fetchStorageLocationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStorageLocationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedStorageLocation = action.payload;
      })
      .addCase(fetchStorageLocationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addStorageLocation.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.StorageLocationList = state.StorageLocationList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(addStorageLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add StorageLocations";
      })
      .addCase(updateStorageLocation.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.StorageLocationList = state.StorageLocationList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(updateStorageLocation.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update StorageLocations";
      })
      .addCase(updateStatusInStorageLocation.fulfilled, (state, action) => {
        // if (!action.payload?.data.id) return;
        // state.StorageLocationList = state.StorageLocationList.map((pkg) =>
        //   pkg.id === action.payload.data.id ? action.payload.data : pkg
        // );
      })

      .addCase(updateStatusInStorageLocation.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch StorageLocations";
      });
  },
});

export default StorageLocationSlice.reducer;
